module.exports = __webpack_public_path__ + "img/cover.14137616.png";